import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../SharedComponents";

interface IDrawdownPriceLockProps extends IProcessComponentProps {
    data: DrawdownModel;
}

interface IDrawdownPriceLockState {}

export class DrawdownPriceLock extends ProcessComponent<IDrawdownPriceLockProps, IDrawdownPriceLockState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;

        return (
            <>
                {SectionHeader("Drawdown Price Lock")}
                <RadiosEditor
                    label="Do you want to apply the Drawdown Price Lock?"
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => onChange({ DrawdownPriceLock: v })}
                    selected={data?.DrawdownPriceLock}
                    cssWrapper="rg-inline mb-10"
                />
                {data?.DrawdownPriceLock && (
                    <>
                        <p>
                            By selecting 'yes' you are confirming you have read and understood the Drawdown Price Lock
                            guide available on the Literature library, and authorise us to make the relevant changes
                        </p>
                        <p className="mb-0">
                            To get the most out of the Drawdown Price Lock, your client`s total platform eligible assets
                            should be at their maximum on the platform prior to the lock being applied.
                        </p>
                        <p>For example, this would mean the lock is applied:</p>
                        <ul>
                            <li>After all transfers have completed;</li>
                            <li>Prior to any fund investments being made;</li>
                            <li>Prior to any tax free lump sum or income being paid; and</li>
                            <li>Prior to any adviser charging being paid.</li>
                        </ul>
                        <p>This is to ensure your client locks in at the lowest possible platform charge.</p>
                        <p>
                            If you want to apply family linking prior to the price lock, please call 0345 279 1001
                            before completing the wizard.
                        </p>
                        <div className="panel-blue">
                            <h3 className="mb-5">
                                <b>Drawdown Price Lock:</b>
                            </h3>
                            <span>{data?.DrawdownPriceLockPercentage}</span>
                        </div>
                    </>
                )}
                <hr />
            </>
        );
    }
}
